import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

//let urlBase = "http://institutogonzalezpalau.ddns.net:8050/api/v2/"; se uso para pruebas
let urlBase = "https://apihistorias.cgap.com.ar/api/v2/";

const handleResponseFactory = (url: string) => {
  return async (response: AxiosResponse<any>) => {
    const { data, status, statusText } = response;
    switch (status) {
      case 200:
      case 201:
      case 204:
        if (data === "") return true;
        else return data;
      case 401:
        throw new Error(
          `${status}: Usuario sin los permisos necesarios para realizar la peticion ${url}`
        );
      case 404:
        throw new Error(
          `${status}: La peticion ${url} no encuentra el recurso`
        );
      case 405:
        throw new Error(
          `${status}: Metodo no permitido para la peticion ${url}`
        );
      case 500:
        throw new Error(`${status}: Error interno del servido ${url}`);
      default:
        throw new Error(`${status}: La peticion ${url} tubo un error`);
    }
  };
};

const useHttp = () => {
  const getPeticion = async (url: string, config?: AxiosRequestConfig) => {
    if (urlBase === "")
      throw new Error("No se ha configurado la ruta base a la api");
    if (url === "")
      throw new Error("No se ha especificado una ruta de peticion a la api");
    const response = config
      ? await axios.get(urlBase + url, config)
      : await axios.get(urlBase + url);
    return handleResponseFactory(url)(response);
  };

  const postPeticion = async (
    url: string,
    dataPeticion: any,
    config?: AxiosRequestConfig
  ) => {
    if (urlBase === "")
      throw new Error("No se ha configurado la ruta base a la api");
    if (url === "")
      throw new Error("No se ha especificado una ruta de peticion a la api");
    const response = config
      ? await axios.post(urlBase + url, dataPeticion, config)
      : await axios.post(urlBase + url, dataPeticion);
    return handleResponseFactory(url)(response);
  };

  const putPeticion = async (
    url: string,
    dataPeticion: any,
    config?: AxiosRequestConfig
  ) => {
    if (urlBase === "")
      throw new Error("No se ha configurado la ruta base a la api");
    if (url === "")
      throw new Error("No se ha especificado una ruta de peticion a la api");
    const response = config
      ? await axios.put(urlBase + url, dataPeticion, config)
      : await axios.put(urlBase + url, dataPeticion);

    return handleResponseFactory(url)(response);
  };

  const patchPeticion = async (
    url: string,
    dataPeticion: any,
    config?: AxiosRequestConfig
  ) => {
    if (urlBase === "")
      throw new Error("No se ha configurado la ruta base a la api");
    if (url === "")
      throw new Error("No se ha especificado una ruta de peticion a la api");
    const response = config
      ? await axios.patch(urlBase + url, dataPeticion, config)
      : await axios.patch(urlBase + url, dataPeticion);
    return handleResponseFactory(url)(response);
  };

  const deletePeticion = async (url: string, config?: AxiosRequestConfig) => {
    if (urlBase === "")
      throw new Error("No se ha configurado la ruta base a la api");
    if (url === "")
      throw new Error("No se ha especificado una ruta de peticion a la api");
    const response = config
      ? await axios.delete(urlBase + url, config)
      : await axios.delete(urlBase + url);
    return handleResponseFactory(url)(response);
  };

  return {
    get: getPeticion,
    post: postPeticion,
    put: putPeticion,
    patch: patchPeticion,
    delete: deletePeticion,
  };
};

export default useHttp;
